import {
  initialState,
  Actions,
  State,
  NEW_NOTIFICATION,
  NEW_NOTIFICATION_SUCCESS,
  NEW_NOTIFICATION_ERROR,
  RESET_NEW_NOTIFICATION,
} from '../../types/notification/new'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_NOTIFICATION:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_NOTIFICATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_NOTIFICATION_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_NEW_NOTIFICATION:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
